import React, { Component } from 'react';
import ReadAllComp from './ReadAllComp';
import CreateUpdate from './CreateUpdate';
import ReadOne from './ReadOne';
import FilterWrapperHOC from './filters/FilterWrapperHOC';

import FilterCardCarousel from './FilterCardCarousel';  // ← ADD ये line


class ReadAll extends Component {
    constructor(props) {
        super(props);
        let state = {
            filterStateMap: {},
            paginationStart: 0,
            pageSize: 25,
            colModelId: '',
            sortFields: null,
            sortOrder: '',
             menuFilterOptions: {},
             activeFilterIndex: null

        }
        if (!props.workflow.parentSession) {
            state = {
                filterStateMap: {},
                paginationStart: props.sortPagination.paginationStart,
                pageSize: props.sortPagination.pageSize
            }
        }
        const { companyDetails } = this.props
        const paginationOption = companyDetails && companyDetails.data && companyDetails.data.companySettings && companyDetails.data.companySettings.paginationOption
        const paginationOptionArray = paginationOption && paginationOption.split(",");

        if (paginationOptionArray) {
            state = {
                filterStateMap: {},
                paginationStart: 0,
                colModelId: '',
                sortFields: null,
                sortOrder: '',
                pageSize: parseInt(paginationOptionArray[0])
            }

        }
        this.state = state;
        this._onFilterChange = this._onFilterChange.bind(this);
        this.onFiltersApplied = this.onFiltersApplied.bind(this);
        this.onUrlSearchFilter = this.onUrlSearchFilter.bind(this);
        this.onClearAppliedFilters = this.onClearAppliedFilters.bind(this);
        this.onSortApplied = this.onSortApplied.bind(this);

        this.loadMenuFilterOptions = this.loadMenuFilterOptions.bind(this);
    }



    loadMenuFilterOptions = () => {
           const { workflowItem, workflow, isBase, sortPagination, container, columnLayoutModel,
            containerIndex,
            columnIndex,
            getInlineActions,
            targetContainerIndex
        } = this.props;
  const filterConfig = this.getFilterConfigFromWorkflowItem(this.props.workflowItem);
  if (!filterConfig || !filterConfig.filters) return;

  filterConfig.filters.forEach((filter, index) => {
    if (filter.useReadAllForOptions && filter.isMenuFilter) {
      const menuPayload = {
        customModelName: filter.menuModel.name, // "Product Category Master"
        typeId: filter.menuModel.id, // 1485
        customerName: workflowItem.typeModel.customerName,
            workflow,
            isBase,
            filters: [],
            filterInAnotherModel: {},
        start: 0,
        count: 1000 // Or large for all categories
      };
      // Trigger read all for menu options (store in state or props)
     
      this.props.triggerFilterReadAll(menuPayload);
    }
  });
}
    onChangePage = (paginationStart, pageSize) => {
        this.setState({ paginationStart, pageSize }, () => {
            this.onFiltersApplied('PAGECHANGE');
        });
    }
    onChangePageSize = (pageSize) => {
        this.setState({ pageSize, paginationStart: 0 }, () => {
            this.onFiltersApplied();
        });
    }
    onSortApplied = (value, sortOrder) => {
        console.log(value, sortOrder);
        this.setState({ sortFields: value, sortOrder }, () => {
            this.onFiltersApplied();
        });
    }

    extractConnectorRuleProperties = (actions) => {
        let propertyArray = [];

        for (let i = 0; i < actions.length; i++) {
            let action = actions[i];
            let connector = action.connector || {};
            let rules = connector.rules || [];

            for (let j = 0; j < rules.length; j++) {
                let rule = rules[j];

                let keyProperty = rule && rule.key && rule.key.property;
                let valueProperty = rule && rule.value && rule.value.property;

                if (keyProperty && propertyArray.indexOf(keyProperty) === -1) {
                    propertyArray.push(keyProperty);
                }

                if (valueProperty && propertyArray.indexOf(valueProperty) === -1) {
                    propertyArray.push(valueProperty);
                }
            }
        }

        return propertyArray;
    };
    getFilterConfigFromWorkflowItem(workflowItem) {
        let config = null;
        const { containerIndex } = this.props;
        if (workflowItem && workflowItem.layoutProperties && workflowItem.layoutProperties.readAllFilterConfig && workflowItem.layoutProperties.readAllFilterConfig[containerIndex] && workflowItem.layoutProperties.readAllFilterConfig[containerIndex].filterConfig) {
            config = workflowItem.layoutProperties.readAllFilterConfig[containerIndex].filterConfig;
        }
        else if (workflowItem && workflowItem.layoutProperties && workflowItem.layoutProperties.readAllFilterConfig && workflowItem.layoutProperties.readAllFilterConfig.filterConfig) {
            config = workflowItem.layoutProperties.readAllFilterConfig.filterConfig;
        }
        return config;
    }
    extractCtValues = (url) => {
        try {
            const parsedUrl = new URL(url);
         
            const ctValue = parsedUrl.searchParams.get('ct');
         
            if (!ctValue) return null;
            const [field, value] = ctValue.split(':');
         

            return { field, value };
        } catch (err) {
            return null;
        }
    };

    onUrlSearchFilter(key) {
      

        const filterConfig = this.getFilterConfigFromWorkflowItem(this.props.workflowItem);
        const filters = filterConfig && filterConfig.filters ? filterConfig.filters : [];
        const test = Object.assign({}, this.state.filterStateMap);
        const filterStateMap = this.state.filterStateMap
      
        const findingCorrectFilter = filters && filters.length && filters.filter((a) => a.targetClassProperty === key.field)
   

        const updatedFilter = {
            "filter_1": {
                ...findingCorrectFilter[0],
                filterBy: [
                    `${key.value}`
                ]
            }

        };



      const filterMap = updatedFilter
     
        const { workflowItem, workflow, isBase, sortPagination, container, columnLayoutModel,
            containerIndex,
            columnIndex,
            getInlineActions,
            targetContainerIndex
        } = this.props;
        const {
            layoutProperties: { readAllFilterConfig, sortConfig, readAllViews, disbableOptimize },
        } = workflowItem;

        const sortFields = this.state.sortFields;
        const alternateTypeModel = container.properties.alternateTypeModel;
        let tableConfig = readAllViews[`${containerIndex}_${columnIndex}`] && readAllViews[`${containerIndex}_${columnIndex}`].table && readAllViews[`${containerIndex}_${columnIndex}`].table;
        if (!tableConfig) {
            tableConfig = readAllViews[containerIndex] && readAllViews[containerIndex].table;
        }
        let recieveFields = [];
        if (tableConfig && tableConfig.isConfigured && tableConfig.config) {
            const tableColumns = tableConfig.config.columns;

            Array.isArray(tableColumns) && tableColumns.map(column => {

                if (column.config && column.config.flyoutField) {

                    const expression = new RegExp(/\{\{(.*?)\}\}/g);
                    const val = column.config.flyoutField.replace(expression, (pattr, matched) => {
                        const columnKey = column.field.classProperty;
                        if (column.field.type === 'TYPE' && !columnKey.startsWith("$$SELF$$")) {

                            const base = columnKey.replace(/[{}]/g, '');       // "funder"
                            const prop = matched.replace(/[{}]/g, '');         // "fundername"
                            const result = `${base}.${prop}`;              // "{{funder.fundername}}"

                            recieveFields.push(result);
                        } else {
                            recieveFields.push(matched);
                        }
                    })
                } else if (column.config && column.config.modelSelector) {

                    const expression = new RegExp(/\{\{(.*?)\}\}/g);
                    const val = column.config.modelSelector.replace(expression, (pattr, matched) => {
                        const columnKey = column.field.classProperty;
                        if (column.field.type === 'TYPE' && !columnKey.startsWith("$$SELF$$")) {

                            const base = columnKey.replace(/[{}]/g, '');       // "funder"
                            const prop = matched.replace(/[{}]/g, '');         // "fundername"
                            const result = `${base}.${prop}`;              // "{{funder.fundername}}"

                            recieveFields.push(result);
                        } else {
                            recieveFields.push(matched);
                        }
                    })
                } else {
                    recieveFields.push(column.field.classProperty)
                }
            })
        }
        const allActions = getInlineActions(workflowItem, targetContainerIndex);
        const menuTypeInlineActionOnly = allActions.inlines
        const extractedAllProperties = this.extractConnectorRuleProperties(menuTypeInlineActionOnly)
        recieveFields.push(...extractedAllProperties);
        const cleanedFields = recieveFields.map(field => {
            const bracketIndex = field.indexOf('[');
            if (bracketIndex !== -1) {
                return field.substring(0, bracketIndex);
            }
            return field;
        });
        recieveFields = cleanedFields
        const payload = {
            customModelName: columnLayoutModel ? columnLayoutModel.name : alternateTypeModel
                ? alternateTypeModel.name : workflowItem.typeModel.name,
            typeId: columnLayoutModel ? this.state.colModelId : alternateTypeModel ? alternateTypeModel.id : workflowItem.typeModel.id,
            customerName: workflowItem.typeModel.customerName,
            workflow,
            isBase,
            filters: [],
            filterInAnotherModel: {}
        };
        if (recieveFields && !disbableOptimize) {
            const tempFields = Object.assign([], recieveFields);
            recieveFields = tempFields.filter((value, index, array) => {
                return array.indexOf(value) === index;
            })
            if (recieveFields.length) {
                payload['recieveFields'] = recieveFields;
            }
        }
        payload.start = key !== 'PAGECHANGE' ? 0 : this.state.paginationStart;
        payload.count = this.state.pageSize;
        sortPagination.paginationStart = key !== 'PAGECHANGE' ? 0 : this.state.paginationStart;
        sortPagination.pageSize = this.state.pageSize;
        if (Object.keys(filterMap).length) {
            for (let filterKey in filterMap) {
                const _f = filterMap[filterKey];
                const { collection, targetClassProperty, isSearch, filterBy, leafType, dateFilterType } = _f;
                if (collection === true) {
                    let modelName = targetClassProperty;
                    let modelProperty = targetClassProperty;
                    if (targetClassProperty.indexOf('.') !== -1) {
                        const splits = targetClassProperty.split('.');
                        modelName = splits.shift();
                        modelProperty = splits.join('.');
                    }
                    payload.filterInAnotherModel = {
                        modelName,
                        modelProperty
                    }
                }
                else {
                    const filterV = filterBy && filterBy.length && (filterBy[0] == 'NULL' || filterBy[0] === "") ? null : filterBy;
                    if (filterV) {
                        payload.filters.push({
                            filterField: targetClassProperty,
                            filterValue: filterV,
                            valueType: leafType,
                            isSearch: isSearch ? true : false,
                            filterOperator: dateFilterType == 'DATERANGE' ? 'BETWEEN' : ''
                        });
                    }
                }
            }
        }
        if (sortPagination.sortField != null) {
            payload.sort = [];
            payload.sort.push({
                sortField: sortPagination.sortField,
                descending: sortPagination.order == 'DESCENDING' ? true : false
            });
        }
        if (sortFields) {
            let sortArr = payload.sort ? payload.sort : [];
            const isDescending = this.state.sortOrder == 'descending' ? true : false;
            sortFields.map(sf => {
                sortArr.push({ "sortField": sf.value, "descending": isDescending })
            });
            payload.sort = sortArr;
        }
        this.props.triggerFilterReadAll(payload);
        this.props.setSortAndPagination(sortPagination);
    }

    onFiltersApplied(key) {
        const filterMap = Object.assign({}, this.state.filterStateMap);
      const { workflowItem, workflow, isBase, sortPagination, container, columnLayoutModel,
            containerIndex,
            columnIndex,
            getInlineActions,
            targetContainerIndex
        } = this.props;
        const {
            layoutProperties: { readAllFilterConfig, sortConfig, readAllViews, disbableOptimize },
        } = workflowItem;

        const filterConfig =
            readAllFilterConfig &&
            readAllFilterConfig[containerIndex] &&
            readAllFilterConfig[containerIndex].filterConfig &&     readAllFilterConfig[containerIndex].filterConfig 
            
            const activeFilter =
                    filterConfig &&
                    filterConfig.filters &&
                    filterConfig.filters[this.state.activeFilterIndex];


            const applyToAllContainers = activeFilter && activeFilter.applyToAllContainers;
            const selectedContainers = activeFilter && activeFilter.containerIndexes;
       
        const sortFields = this.state.sortFields;
        const alternateTypeModel = container.properties.alternateTypeModel;
        let tableConfig = readAllViews[`${containerIndex}_${columnIndex}`] && readAllViews[`${containerIndex}_${columnIndex}`].table && readAllViews[`${containerIndex}_${columnIndex}`].table;
        if (!tableConfig) {
            tableConfig = readAllViews[containerIndex] && readAllViews[containerIndex].table;
        }
        let recieveFields = [];
        if (tableConfig && tableConfig.isConfigured && tableConfig.config) {
            const tableColumns = tableConfig.config.columns;

            Array.isArray(tableColumns) && tableColumns.map(column => {

                if (column.config && column.config.flyoutField) {

                    const expression = new RegExp(/\{\{(.*?)\}\}/g);
                    const val = column.config.flyoutField.replace(expression, (pattr, matched) => {
                        const columnKey = column.field.classProperty;
                        if (column.field.type === 'TYPE' && !columnKey.startsWith("$$SELF$$")) {

                            const base = columnKey.replace(/[{}]/g, '');       // "funder"
                            const prop = matched.replace(/[{}]/g, '');         // "fundername"
                            const result = `${base}.${prop}`;              // "{{funder.fundername}}"

                            recieveFields.push(result);
                        } else {
                            recieveFields.push(matched);
                        }
                    })
                } else if (column.config && column.config.modelSelector) {

                    const expression = new RegExp(/\{\{(.*?)\}\}/g);
                    const val = column.config.modelSelector.replace(expression, (pattr, matched) => {
                        const columnKey = column.field.classProperty;
                        if (column.field.type === 'TYPE' && !columnKey.startsWith("$$SELF$$")) {

                            const base = columnKey.replace(/[{}]/g, '');       // "funder"
                            const prop = matched.replace(/[{}]/g, '');         // "fundername"
                            const result = `${base}.${prop}`;              // "{{funder.fundername}}"

                            recieveFields.push(result);
                        } else {
                            recieveFields.push(matched);
                        }
                    })
                } else {
                    recieveFields.push(column.field.classProperty)
                }
            })
        }
        const allActions = getInlineActions(workflowItem, targetContainerIndex);
        const menuTypeInlineActionOnly = allActions.inlines
        const extractedAllProperties = this.extractConnectorRuleProperties(menuTypeInlineActionOnly)
        recieveFields.push(...extractedAllProperties);
        const cleanedFields = recieveFields.map(field => {
            const bracketIndex = field.indexOf('[');
            if (bracketIndex !== -1) {
                return field.substring(0, bracketIndex);
            }
            return field;
        });
        recieveFields = cleanedFields
        const payload = {
            customModelName: columnLayoutModel ? columnLayoutModel.name : alternateTypeModel
                ? alternateTypeModel.name : workflowItem.typeModel.name,
            typeId: columnLayoutModel ? this.state.colModelId : alternateTypeModel ? alternateTypeModel.id : workflowItem.typeModel.id,
            customerName: workflowItem.typeModel.customerName,
            workflow,
            isBase,
            filters: [],
            filterInAnotherModel: {}
        };
        if (recieveFields && !disbableOptimize) {
            const tempFields = Object.assign([], recieveFields);
            recieveFields = tempFields.filter((value, index, array) => {
                return array.indexOf(value) === index;
            })
            if (recieveFields.length) {
                payload['recieveFields'] = recieveFields;
            }
        }
        payload.start = key !== 'PAGECHANGE' ? 0 : this.state.paginationStart;
        payload.count = this.state.pageSize;
        sortPagination.paginationStart = key !== 'PAGECHANGE' ? 0 : this.state.paginationStart;
        sortPagination.pageSize = this.state.pageSize;
        if (Object.keys(filterMap).length) {
            for (let filterKey in filterMap) {
                const _f = filterMap[filterKey];
                const { collection, targetClassProperty, isSearch, filterBy, leafType, dateFilterType } = _f;
                if (collection === true) {
                    let modelName = targetClassProperty;
                    let modelProperty = targetClassProperty;
                    if (targetClassProperty.indexOf('.') !== -1) {
                        const splits = targetClassProperty.split('.');
                        modelName = splits.shift();
                        modelProperty = splits.join('.');
                    }
                    payload.filterInAnotherModel = {
                        modelName,
                        modelProperty
                    }
                }
                else {
                    const filterV = filterBy && filterBy.length && (filterBy[0] == 'NULL' || filterBy[0] === "") ? null : filterBy;
                    if (filterV) {
                        payload.filters.push({
                            filterField: targetClassProperty,
                            filterValue: filterV,
                            valueType: leafType,
                            isSearch: isSearch ? true : false,
                            filterOperator: dateFilterType == 'DATERANGE' ? 'BETWEEN' : ''
                        });
                    }
                }
            }
        }
        if (sortPagination.sortField != null) {
            payload.sort = [];
            payload.sort.push({
                sortField: sortPagination.sortField,
                descending: sortPagination.order == 'DESCENDING' ? true : false
            });
        }
        if (sortFields) {
            let sortArr = payload.sort ? payload.sort : [];
            const isDescending = this.state.sortOrder == 'descending' ? true : false;
            sortFields.map(sf => {
                sortArr.push({ "sortField": sf.value, "descending": isDescending })
            });
            payload.sort = sortArr;
        }

if (applyToAllContainers && selectedContainers && selectedContainers.length) {

   selectedContainers.forEach(index => {

      const containerId = 'c' + index;


      this.props.triggerFilterReadAll(payload, containerId);

   });

} else {

   this.props.triggerFilterReadAll(payload);

}
        this.props.setSortAndPagination(sortPagination);
    }
    onClearAppliedFilters() {
        const { workflowItem, workflow, isBase, container, columnLayoutModel } = this.props;
        const alternateTypeModel = container.properties.alternateTypeModel;
        const payload = {
            customModelName: columnLayoutModel ? columnLayoutModel.name : alternateTypeModel
                ? alternateTypeModel.name : workflowItem.typeModel.name,
            typeId: columnLayoutModel ? this.state.colModelId : alternateTypeModel ? alternateTypeModel.id : workflowItem.typeModel.id,
            customerName: workflowItem.typeModel.customerName,
            workflow,
            isBase,
            filters: []
        };
        this.setState({ filterStateMap: {} });
        this.props.triggerFilterReadAll(payload);
    }
    _onFilterChange(filterConfig, filterBy) {
        if (!filterBy) {
            this.setState({
                filteredDataList: this._dataList,
            });
        }
        const { filter, filterIndex } = filterConfig;
        const { filterStateMap } = this.state;
        filter.filterBy = filterBy
        if (filterBy.length == 0) {
            delete filterStateMap[`filter_${filterIndex}`];
        } else {
            filterStateMap[`filter_${filterIndex}`] = filter;
        }

         this.setState({
        filterStateMap,
        activeFilterIndex: filterIndex
    });
    }

     componentDidMount() {
        const { columnLayoutModel } = this.props;
        if (columnLayoutModel && columnLayoutModel.name) {
            const self = this;
            this.props.getModelByNamePromise({ name: columnLayoutModel.name }).then((res) => {
                const model = res.data;
                const typeId = model.id;
                self.setState({ colModelId: typeId })
            });
        }
        this.setState({ paginationStart: 0, pageSize: 25 });
        this.props.resetSortAndPagination();
        const currentUrl = window.location.href;
        const urlFilterValue = this.extractCtValues(currentUrl);
          this.loadMenuFilterOptions();
        if (urlFilterValue) {
            this.onUrlSearchFilter(urlFilterValue);
        }


        if (this.props.workflow && this.props.workflow.collections) {
    const collections = this.props.workflow.collections
   
    const filterConfig = this.getFilterConfigFromWorkflowItem(this.props.workflowItem);
    if (filterConfig && filterConfig.filters) {
        filterConfig.filters.forEach(function(filter, filterIndex) {
            if (filter.useReadAllForOptions && filter.isMenuFilter) {
             const modelProp = filter.menuModel.name;
                  const targetProp = filter.targetClassProperty;
                  const collectionKey = Object.keys(collections).find(key =>
    key.startsWith(modelProp + '_c')
);


const typeModelCollection = collectionKey ? collections[collectionKey] : undefined;

                if (typeModelCollection && !typeModelCollection.isLoading) {
                    this.setState(function(prev) {
                        return {
                            menuFilterOptions: {
                              ...prev.menuFilterOptions,  // ✅ Spread operator
                     [targetProp]: {
                                    data: typeModelCollection.data,
                                    config: filter  // ✅ Full config save for card rendering
                                }}
                        };
                    });
                }
            }
        }.bind(this));
    }
}



    }

    componentWillUnmount() {
        this.setState({ paginationStart: 0, pageSize: 25 });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.workflow.workflowModel !== nextProps.workflow.workflowModel) {
            this.setState({ paginationStart: 0, pageSize: 25 });
        } else {
            const { sortPagination } = nextProps;
            this.setState({ paginationStart: sortPagination.paginationStart, pageSize: this.state.pageSize });
        }


if (nextProps.workflow && nextProps.workflow.collections) {
    const collections = nextProps.workflow.collections
   
    const filterConfig = this.getFilterConfigFromWorkflowItem(this.props.workflowItem);
    if (filterConfig && filterConfig.filters) {
        filterConfig.filters.forEach(function(filter, filterIndex) {
            if (filter.useReadAllForOptions && filter.isMenuFilter) {
                const modelProp = filter.menuModel.name;
                  const targetProp = filter.targetClassProperty;
                  const collectionKey = Object.keys(collections).find(key =>
    key.startsWith(modelProp + '_c')
);


const typeModelCollection = collectionKey ? collections[collectionKey] : undefined;
               
                if (typeModelCollection && !typeModelCollection.isLoading) {
                    this.setState(function(prev) {
                        return {
                            menuFilterOptions: {
                              ...prev.menuFilterOptions,  // ✅ Spread operator
                     [targetProp]: {
                                    data: typeModelCollection.data,
                                    config: filter  // ✅ Full config save for card rendering
                                }}
                        };
                    });
                }
            }
        }.bind(this));
    }
}




}

    renderMenuFilters() {
    const filterConfig = this.getFilterConfigFromWorkflowItem(this.props.workflowItem);
    if (!filterConfig || !filterConfig.filters || !filterConfig.filters.length) {
        return null;
    }

 const hasMenuFilter = filterConfig && filterConfig.filters && filterConfig.filters.some(function(filter) {
  return filter.isMenuFilter === true;
});

if(!hasMenuFilter) return null ;

    return (
        <div className="menu-filters-section p-3 bg-light">
            {filterConfig.filters.map(function(filter, index) {
                if (filter.useReadAllForOptions && filter.isMenuFilter) {
                    const targetProp = filter.targetClassProperty;
                    const menuFilterOptions = this.state.menuFilterOptions && this.state.menuFilterOptions[targetProp] || {};
                    const options = menuFilterOptions && menuFilterOptions.data || [];
                    
                    // CHANGE: cardTextClassProperty use करो
                 const splits = filter.cardTextClassProperty.split('.');
             const displayProp = splits[splits.length - 1];
                    
                    const filterStateMap = this.state.filterStateMap;
                    const currentValue = filterStateMap[`filter_${index}`] &&
                                        filterStateMap[`filter_${index}`].filterBy &&
                                        filterStateMap[`filter_${index}`].filterBy[0] || '';

                    // NEW: Image carousel check
                    if (filter.cardImageClassProperty) {
                        const imageSplits = filter.cardImageClassProperty.split('.');
                        const imageProp = imageSplits[imageSplits.length - 1];
                        
                        return (
                            <FilterCardCarousel
                                key={targetProp + '_' + index}
                                filter={filter}
                                filterIndex={index}
                                options={options}
                                currentValue={currentValue}
                                displayProp={displayProp}
                                imageProp={imageProp}
                                displayName={filter.displayName}
                                onFilterChange={this._onFilterChange}
                                onFiltersApplied={this.onFiltersApplied}
                            />
                        );
                    }


                    return (
                        <select
                            key={targetProp + '_' + index}
                            className="form-select me-3 mb-2"
                            style={{minWidth: '150px'}}
                            value={currentValue}
                            onChange={function(e) {
                                this._onFilterChange(
                                    {filter: filter, filterIndex: index},
                                    e.target.value ? [e.target.value] : []
                                );
                                setTimeout(function() {
                                    this.onFiltersApplied();
                                }.bind(this), 0);
                            }.bind(this)}
                        >
                            <option value="">All {filter.displayName}</option>
                            {options.map(function(item, idx) {
                                return (
                                    <option key={idx} value={item[displayProp]}>
                                        {item[displayProp]}
                                    </option>
                                );
                            })}
                        </select>
                    );
                }
                return null;
            }.bind(this))}
        </div>
    );
}


    render() {
        const { container, columnIndex, workflowItem, containerIndex, viewMode, companyDetails } = this.props;
        const {
            layoutProperties: { readAllFilterConfig, sortConfig },
        } = workflowItem;
        const fetchAfterFilter =
            readAllFilterConfig &&
            readAllFilterConfig[containerIndex] &&
            readAllFilterConfig[containerIndex].filterConfig &&
            readAllFilterConfig[containerIndex].filterConfig.fetchAfterFilter;

        const { paginationStart, pageSize } = this.state;
        const { properties, properties: { colLayoutConfig, isStatic } } = container;
        const colOperation = colLayoutConfig && colLayoutConfig[`colOperation-${columnIndex}`];
        const { keyed, table, imageCard } =
            workflowItem.layoutProperties.readAllViews[`${containerIndex}_${columnIndex}`] ||
            workflowItem.layoutProperties.readAllViews[containerIndex | ""] || workflowItem.layoutProperties.readAllViews;
        const selectedTemplate = companyDetails && companyDetails.data != null && companyDetails.data.companySettings && companyDetails.data.companySettings.tableTemplate
            ? companyDetails.data.companySettings.tableTemplate : table && table.isConfigured && table.selectedTemplate;
        const keyedConfig = keyed && keyed.config;
        const imagecardConfig = imageCard && imageCard.config;
        const columns = table && table.isConfigured && table.config.columns;
        const tableStyleConfig = table && table.config && table.config.tableStyleConfig;
        const locationEnumeratorConfig = keyedConfig && keyedConfig.locationEnumeratorConfig;
        const keyedPagination = locationEnumeratorConfig != null ? locationEnumeratorConfig.allowPagination : false;
        const showThumnailImage = companyDetails && companyDetails.data != null && companyDetails.data.companySettings && companyDetails.data.companySettings.showThumnailImage;
        const filterTemplateCompany = companyDetails && companyDetails.data != null && companyDetails.data.companySettings && companyDetails.data.companySettings.filterTemplate;
        const filterPlacement = companyDetails && companyDetails.data != null && companyDetails.data.companySettings && companyDetails.data.companySettings.filterPlacement;
        const thmbnailFormatSelection = companyDetails && companyDetails.data != null && companyDetails.data.companySettings && companyDetails.data.companySettings.thmbnailFormatSelection;
        const filterTemplate =
            readAllFilterConfig &&
            readAllFilterConfig[containerIndex] &&
            readAllFilterConfig[containerIndex].filterConfig && readAllFilterConfig[containerIndex].filterConfig.templateType && readAllFilterConfig[containerIndex].filterConfig.templateType.value

        const sortFieldsConfig =
            sortConfig &&
            sortConfig[containerIndex] &&
            sortConfig[containerIndex].sortFieldsConfig &&
            sortConfig[containerIndex].sortFieldsConfig.sorts;
        //    if(selectedTemplate === 'Template2'){
        //     return (
        //         <div className='h-100'>
        //             {
        //                 (isStatic === false && colOperation && colOperation != 'READALL') || (!colOperation && isStatic === false) ?
        //                     <ReadOne {...this.props} /> :
        //                     <FilterWrapperHOC
        //                         pagination={viewMode === "KEYED" ? keyedPagination : false}
        //                         paginationStart={paginationStart}
        //                         pageSize={pageSize}
        //                         onChangePageSize={this.onChangePageSize}
        //                         onChangePage={this.onChangePage}
        //                         filterStateMap={this.state.filterStateMap}
        //                         onFiltersApplied={this.onFiltersApplied}
        //                         onFilterChange={this._onFilterChange}
        //                         onClearAppliedFilters={this.onClearAppliedFilters}
        //                         {...this.props}
        //                     >
        //                         <ReadAllComp 
        //                             pagination={viewMode === "KEYED" ? keyedPagination : false}
        //                             paginationStart={paginationStart}
        //                             pageSize={100000}
        //                             onFiltersApplied={this.onFiltersApplied}
        //                             onFilterChange={this._onFilterChange}
        //                                 filterMap = {Object.assign({}, this.state.filterStateMap)}
        //                             {...this.props} />
        //                     </FilterWrapperHOC>
        //             }
        //         </div>
        //     );  
        //    }


        return (
            <div className='h-100'>

                {this.renderMenuFilters()}
                {
                    (isStatic === false && colOperation && colOperation != 'READALL') || (!colOperation && isStatic === false) ?
                        <ReadOne {...this.props} /> :
                        <FilterWrapperHOC
                            pagination={viewMode === "KEYED" ? keyedPagination : true}
                            paginationStart={paginationStart}
                            pageSize={pageSize}
                            onChangePageSize={this.onChangePageSize}
                            onChangePage={this.onChangePage}
                            filterStateMap={this.state.filterStateMap}
                            onFiltersApplied={this.onFiltersApplied}
                            onFilterChange={this._onFilterChange}
                            onClearAppliedFilters={this.onClearAppliedFilters}
                            selectedTemplate={selectedTemplate}
                            showThumnailImage={showThumnailImage}
                            thmbnailFormatSelection={thmbnailFormatSelection}
                            tableStyleConfig={tableStyleConfig}
                              imagecardConfig={imagecardConfig}
                            fetchAfterFilter={fetchAfterFilter}
                            filterTemplate={filterTemplate}
                            filterTemplateCompany={filterTemplateCompany}
                            filterPlacement={filterPlacement}
                            sortFieldsConfig={sortFieldsConfig}
                            onSortApplied={this.onSortApplied}
                            horizontalViewMode={imagecardConfig && imagecardConfig.config && imagecardConfig.config.horizontalViewMode}
                            {...this.props}
                        >
                            <ReadAllComp
                                pagination={viewMode === "KEYED" ? keyedPagination : true}
                                paginationStart={paginationStart}
                                pageSize={tableStyleConfig && tableStyleConfig.enablePagination ? 1000000 : pageSize}
                                fetchAfterFilter={fetchAfterFilter}
                                filterTemplate={filterTemplate}
                                filterTemplateCompany={filterTemplateCompany}
                                filterPlacement={filterPlacement}
                                filterMap={Object.assign({}, this.state.filterStateMap)}
                                filterStateMap={this.state.filterStateMap}
                                onFiltersApplied={this.onFiltersApplied}
                                onFilterChange={this._onFilterChange}
                                colModelId={this.state.colModelId}
                                onClearAppliedFilters={this.onClearAppliedFilters}
                                {...this.props} />
                        </FilterWrapperHOC>
                }
            </div>
        );
    }
}

export default ReadAll;